import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { OutlinedInput, InputAdornment, Card, Select, MenuItem, TextField, Box, CardContent, Autocomplete, Button, FormControl, CardHeader, Grid } from '@mui/material';

const Inicio = () => {
    return (
        <div className='content'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Card>
                        <CardHeader>
                            Inicio
                        </CardHeader>
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export {
    Inicio
}
